// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__k9rAN","avatar__menu":"styles_avatar__menu__9LtyP","avatar__menu--active":"styles_avatar__menu--active__k6jfS"};